document.addEventListener('alpine:init', () => {
  // --- GŁÓWNY KOMPONENT KOSZYKA ---
  Alpine.data('CartItems', () => ({
    itemsRoot: null,
    loading: false,
    giftRefreshSequence: 0,

    init() {
      this.itemsRoot = this.$root;

      window.addEventListener('baseline:cart:afteradditem', this.onCartQuantityChange.bind(this));
      window.addEventListener('baseline:cart:cartqtychange', this.onCartQuantityChange.bind(this));
      window.addEventListener('baseline:cart:update', this.onCartQuantityChange.bind(this));

      document.addEventListener('baseline:cart:lock', () => { this.loading = true; });
      document.addEventListener('baseline:cart:unlock', () => { this.loading = false; });
    },

    onCartQuantityChange(e) {
      if (!e.detail.response || !e.detail.response.sections) return;

      const newHtml = e.detail.response.sections['cart-items'];
      if (!newHtml) return;
      const giftRefreshSequence = ++this.giftRefreshSequence;
      const giftWasOpen = Boolean(this.itemsRoot.querySelector('[data-nt-gift][open]'));

      // Obsługa pustego koszyka (Hard Reset)
      if (e.detail.response.item_count === 0) {
        this.itemsRoot.innerHTML = new DOMParser().parseFromString(newHtml, 'text/html').querySelector('[data-cart-items]').innerHTML;
        const footerPrice = document.querySelector('.cd-total-price');
        if (footerPrice) footerPrice.innerText = (window.formatMoney ? window.formatMoney(0) : '0.00');
        this.loading = false;
        return;
      }

      // Odroczenie morph żeby uniknąć freeze przy 2–3 produktach
      const htmlToMorph = newHtml;
      const root = this.itemsRoot;
      const detail = e.detail;
      const self = this;
      const doMorph = () => {
        try {
          Alpine.morph(
            root,
            querySelectorInHTMLString('[data-cart-items]', htmlToMorph).outerHTML
          );
        } catch (error) {
          console.warn('Morph failed, using innerHTML fallback', error);
          root.innerHTML = new DOMParser().parseFromString(htmlToMorph, 'text/html').querySelector('[data-cart-items]').innerHTML;
        }
        self.$nextTick(() => {
          self.refreshGiftPackaging(detail.response.sections, giftRefreshSequence, giftWasOpen);
          root.querySelectorAll('[x-data]').forEach(el => {
            el.dispatchEvent(new CustomEvent('cart:hard-reset'));
          });
          if (detail.response.sections['cart-live-region']) {
            self.updateLiveRegion(
              parseDOMFromString(detail.response.sections['cart-live-region']).firstElementChild.textContent
            );
          }
          if (detail.originalTarget && document.contains(detail.originalTarget)) {
            if (!root.contains(detail.originalTarget)) {
              const focusRoot = root.closest('[role="dialog"]')?.parentNode || root;
              if (self.$focus) self.$focus.within(focusRoot).first();
            }
          }
          self.loading = false;
          document.dispatchEvent(new CustomEvent('baseline:cart:unlock'));
        });
      };
      if (detail.ntcSample) {
        doMorph();
      } else if (typeof requestIdleCallback !== 'undefined') {
        requestIdleCallback(doMorph, { timeout: 120 });
      } else {
        setTimeout(doMorph, 0);
      }
    },

    async refreshGiftPackaging(sections, sequence, wasOpen) {
      const slot = this.itemsRoot.querySelector('[data-nt-gift-slot]');
      const sectionId = this.itemsRoot.closest('[data-nt-gift-section-id]')?.dataset.ntGiftSectionId;
      if (!slot || !sectionId) return;
      try {
        let html = sections[sectionId];
        if (!html) {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + '?sections=' + encodeURIComponent(sectionId));
          if (!response.ok) throw new Error('Gift section refresh failed');
          html = (await response.json())[sectionId];
        }
        if (sequence !== this.giftRefreshSequence || !html || !slot.isConnected) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const drawerTemplate = parsed.querySelector('template[x-teleport]');
        if (!drawerTemplate) throw new Error('Gift drawer template missing');
        const card = drawerTemplate.content.querySelector('[data-nt-gift]');
        if (wasOpen && card) card.setAttribute('open', '');
        slot.replaceChildren(...(card ? [card] : []));
      } catch (error) {
        console.warn('Gift packaging refresh failed', error);
      }
    },

    updateLiveRegion(text) {
      if (!text) return;
      const status = document.getElementById('cart-live-region-text');
      if (status) {
        status.textContent = text;
        status.setAttribute('aria-hidden', 'false');
        setTimeout(() => status.setAttribute('aria-hidden', 'true'), 1000);
      }
    }
  }));

  Alpine.data('CartItem', (initialKey, initialQty) => ({
    key: initialKey,
    quantity: initialQty, // Ustawiamy to, co przyszło z Liquida (HTML), a nie 1!
    loading: false,
    locked: false,
    removing: false,
    errorMessage: null,
    observer: null,
    _changeTimeout: null,

    init() {
      // Jeśli z jakiegoś powodu initialQty nie przyszło, spróbuj pobrać z HTML
      if (!this.quantity) {
        this.syncFromHTML();
      }

      // ... reszta Twojego kodu init (MutationObserver itd.) ...
      if (this.$refs.quantityInput) {
        this.observer = new MutationObserver((mutations) => {
          for (const mutation of mutations) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-quantity') {
              this.syncFromHTML();
            }
          }
        });
        this.observer.observe(this.$refs.quantityInput, { attributes: true });
      }

      this.$el.addEventListener('cart:hard-reset', () => { this.syncFromHTML(); });
    },

    destroy() {
      // Sprzątanie observera przy usuwaniu elementu
      if (this.observer) this.observer.disconnect();
    },

    // Funkcja resetująca stan na podstawie HTML
    syncFromHTML() {
      // Always clear transient states that may have been inherited from a different item's DOM position
      this.removing = false;
      this.loading = false;
      this.errorMessage = null;

      if (this.$refs.quantityInput) {
        // Czytamy TYLKO z data-quantity (bo value może być zablokowane przez Alpine)
        const serverVal = parseInt(this.$refs.quantityInput.getAttribute('data-quantity'));

        // Jeśli serwer mówi np. "4", a my mamy inną wartość, aktualizujemy
        if (!isNaN(serverVal) && serverVal > 0 && serverVal !== this.quantity) {
          console.log(`[CartItem] Sync: Server=${serverVal}, Local=${this.quantity} -> Updating`);

          // 1. Aktualizujemy zmienną w Alpine
          this.quantity = serverVal;

          // 2. Brutalnie wymuszamy wartość w DOM, żeby wizualnie się zgadzało
          this.$refs.quantityInput.value = serverVal;
        }

        // Aktualizacja klucza
        const currentKey = this.$root.dataset.lineItemKey;
        if (currentKey) this.key = currentKey;
      }
    },

    increment() {
      this.quantity++;
      this.debouncedQuantityChange();
    },

    decrement() {
      if (this.quantity > 1) {
        this.quantity--;
        this.debouncedQuantityChange();
      }
    },

    removeItem() {
      if (this.locked) return;
      this.removing = true;
      this.quantity = 0;
      this.itemQuantityChange();
    },

    debouncedQuantityChange() {
      if (this._changeTimeout) clearTimeout(this._changeTimeout);
      this._changeTimeout = setTimeout(() => {
        this._changeTimeout = null;
        this.itemQuantityChange();
      }, 380);
    },

    async itemQuantityChange() {
      const currentKey = this.$root.dataset.lineItemKey || this.key;

      if (!currentKey) return;
      if (this.locked || this.loading) return;

      this.locked = true;
      this.loading = true;
      document.dispatchEvent(new CustomEvent('baseline:cart:lock'));

      const requestBody = {
        id: currentKey,
        quantity: this.quantity,
        sections: 'cart-items,cart-footer,cart-item-count,cart-live-region',
        sections_url: window.location.pathname
      };

      try {
        const routeUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/change.js';
        let response = await fetch(routeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
          body: JSON.stringify(requestBody)
        });

        let data = await response.json();

        // Retry-by-line-index: bundle items mogą mieć nieaktualny klucz po recalculation rabatu Shopify Functions.
        // Jeśli pierwsze wywołanie zwróciło "Cart Error: ... id ..." próbujemy jeszcze raz przekazując 1-based index linii.
        // Aby uniknąć błędnego indeksu gdy drawer i main cart są na stronie jednocześnie, fallback robimy przez fetch /cart.js
        // żeby dopasować po kombinacji variant_id + properties.
        if (!response.ok || data.status === 422 || data.errors) {
          try {
            const cartResp = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart.js', {
              headers: { 'Accept': 'application/json' }
            });
            const cartJson = await cartResp.json();
            const wrapper = this.$root;
            const myVariantId = parseInt(wrapper.dataset.productId || '0'); // product_id, ale variant ID nie mamy w DOM
            const myKeyOld = wrapper.dataset.lineItemKey || '';
            // Spróbuj dopasować po starym kluczu (jeśli wciąż istnieje) lub po pozycji w karcie
            let lineIndex = 0;
            if (cartJson && cartJson.items) {
              for (let i = 0; i < cartJson.items.length; i++) {
                if (cartJson.items[i].key === myKeyOld) { lineIndex = i + 1; break; }
              }
              // Jeśli stary klucz nie znaleziony, szukamy po variant_id + key prefix
              if (lineIndex === 0 && myKeyOld) {
                const variantIdFromKey = parseInt(myKeyOld.split(':')[0]) || 0;
                for (let i = 0; i < cartJson.items.length; i++) {
                  if (cartJson.items[i].variant_id === variantIdFromKey) { lineIndex = i + 1; break; }
                }
              }
            }
            if (lineIndex > 0) {
              const retryBody = {
                line: lineIndex,
                quantity: this.quantity,
                sections: 'cart-items,cart-footer,cart-item-count,cart-live-region',
                sections_url: window.location.pathname
              };
              const retryResp = await fetch(routeUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
                body: JSON.stringify(retryBody)
              });
              const retryData = await retryResp.json();
              if (retryResp.ok && !retryData.errors && retryData.status !== 422) {
                response = retryResp;
                data = retryData;
              }
            }
          } catch (retryErr) {
            console.warn('[cart] retry-by-line-index failed', retryErr);
          }
        }

        if (!response.ok || data.status === 422 || data.errors) {
          throw new Error(data.message || (window.cartI18n && window.cartI18n.cartError) || 'There was an error updating your cart. Please try again.');
        }

        // Sukces
        this.errorMessage = null;
        document.body.dispatchEvent(new CustomEvent('baseline:cart:cartqtychange', {
          bubbles: true,
          detail: {
            response: data,
            key: currentKey,
            quantity: this.quantity,
            originalTarget: this.$refs.quantityInput
          }
        }));

      } catch (e) {
        console.error('Cart Error:', e);
        // W razie błędu przywracamy stan z HTML (ostatni znany dobry)
        this.syncFromHTML();
        this.errorMessage = e.message || (window.cartI18n && window.cartI18n.genericError) || "Something went wrong."
        document.dispatchEvent(new CustomEvent('theme:line-item:error', {
          detail: { message: this.errorMessage, key: currentKey }
        }));
      } finally {
        this.locked = false;
        this.loading = false;
        document.dispatchEvent(new CustomEvent('baseline:cart:unlock'));
      }
    }
  }));
});

window.removeBundle = async function (bundleId, btn) {
  if (!bundleId) return;
  if (btn) {
    btn.disabled = true;
    btn.style.opacity = '0.5';
  }
  document.dispatchEvent(new CustomEvent('baseline:cart:lock'));

  const items = document.querySelectorAll('.cd-item-wrapper[data-bundle-id="' + bundleId + '"]');
  const updates = {};
  items.forEach(el => {
    const key = el.getAttribute('data-line-item-key');
    if (key) {
      updates[key] = 0;
    }
  });

  if (Object.keys(updates).length === 0) {
    if (btn) { btn.disabled = false; btn.style.opacity = '1'; }
    document.dispatchEvent(new CustomEvent('baseline:cart:unlock'));
    return;
  }

  try {
    const routeUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/update.js';
    const response = await fetch(routeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({
        updates: updates,
        sections: 'cart-items,cart-footer,cart-item-count,cart-live-region',
        sections_url: window.location.pathname
      })
    });
    const data = await response.json();

    document.body.dispatchEvent(new CustomEvent('baseline:cart:cartqtychange', {
      bubbles: true,
      detail: { response: data }
    }));

    // --- CZYSCZENIE ZNIŻKI ---
    // Sprawdź czy po usunięciu w koszyku pozostały jeszcze jakieś inne zestawy
    const cartCheckResp = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart.js');
    const cartCheckData = await cartCheckResp.json();
    const remainingBundles = cartCheckData.items.filter(item =>
      item.properties && item.properties['_multipack_bundle_id']
    );

    if (remainingBundles.length === 0) {
      // Brak jakichkolwiek bundli w koszyku — czyścimy kod rabatowy z sesji Shopify
      let iframe = document.getElementById('multipack-discount-clear-iframe');
      if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.id = 'multipack-discount-clear-iframe';
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
      }
      // Shopify clears the active discount when navigating to /discount/ z pustym kodem
      iframe.src = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'discount/');

      // Usun tez pole discount z formularzy koszyka
      document.querySelectorAll('form[action*="/cart"] input[name="discount"]').forEach(el => el.remove());
    }
    // --- KONIEC CZYSCZENIA ZNIŻKI ---

  } catch (e) {
    console.error('Bundle remove error', e);
    if (btn) { btn.disabled = false; btn.style.opacity = '1'; }
  } finally {
    document.dispatchEvent(new CustomEvent('baseline:cart:unlock'));
  }
};

window.updateCartLoyaltyPoints = function (rows) {
  var shop = (window.Shopify && window.Shopify.shop) || 'nutupl.myshopify.com';
  var url = '/apps/quantity-breaker/config?shop=' + shop;
  // Liczby do zapowiedzi punktów (pkt za zł, mnożniki) bierzemy z aplikacji KLUBU — to ona nalicza
  // punkty. Stara aplikacja quantity-breaker (progi ilościowe + „Complete the Look") nie zna mnożnika
  // za zestaw, więc koszyk zaniżał zapowiedź dla zestawów (×1 zamiast mnożnika z panelu klubu).
  // Jedno zapytanie na stronę; gdy klub nie odpowie, zostają liczby z quantity-breaker.
  if (!window.__ntcLoyaltyCfg) {
    window.__ntcLoyaltyCfg = fetch('/apps/nous-loyalty/config?shop=' + shop)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { return d && d.loyalty ? d.loyalty : null; })
      .catch(function () { return null; });
  }
  Promise.all([fetch(url).then(function (r) { return r.json(); }), window.__ntcLoyaltyCfg]).then(function (res) {
    var data = res[0];
    if (data && res[1]) {
      data.loyalty = data.loyalty || {};
      for (var klucz in res[1]) { if (res[1][klucz] != null) data.loyalty[klucz] = res[1][klucz]; }
    }
    var config = data;

    // --- Complete the Look: upsell rendering (runs first, before loyalty check) ---
    var lookPairs = Array.isArray(config.lookPairs) ? config.lookPairs : [];

    // Clear existing match containers
    document.querySelectorAll('.cd-match-container').forEach(function (el) { el.innerHTML = ''; });

    if (lookPairs.length > 0) {
      // Parse cart items from b64 for product ID matching
      var cartItems = [];
      if (rows.length > 0 && rows[0].hasAttribute('data-cart-items-b64')) {
        try {
          var b64 = rows[0].getAttribute('data-cart-items-b64');
          var jsonStr = decodeURIComponent(escape(window.atob(b64)));
          cartItems = JSON.parse(jsonStr);
        } catch (e) { }
      }
      var cartProductIds = cartItems.map(function (it) { return String(it.productId); });
      var shown = {};

      lookPairs.forEach(function (pair) {
        var aId = String(pair.productA.id).replace(/^gid:\/\/shopify\/Product\//, '');
        var bId = String(pair.productB.id).replace(/^gid:\/\/shopify\/Product\//, '');
        var upsellProduct = null;
        var triggerProductId = null;

        if (cartProductIds.indexOf(aId) >= 0 && cartProductIds.indexOf(bId) < 0) {
          upsellProduct = pair.productB;
          triggerProductId = aId;
        } else if (cartProductIds.indexOf(bId) >= 0 && cartProductIds.indexOf(aId) < 0) {
          upsellProduct = pair.productA;
          triggerProductId = bId;
        }

        if (upsellProduct && triggerProductId && !shown[upsellProduct.id]) {
          shown[upsellProduct.id] = true;

          var containers = document.querySelectorAll('.cd-match-container[data-match-for="' + triggerProductId + '"]');
          if (containers && containers.length > 0) {
            // Konwersja ceny z waluty bazowej sklepu (PLN) na aktywną walutę rynku (np. EUR).
            // Shopify wystawia kurs przez window.Shopify.currency.rate. Jeśli brak – fallback 1 (bez konwersji).
            var fxRate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate)
              ? parseFloat(window.Shopify.currency.rate) : 1;
            if (!(fxRate > 0)) { fxRate = 1; }
            var priceShop = parseFloat(upsellProduct.price) || 0;
            var discType = pair.discountType || 'PERCENT';
            var discVal = pair.discountValue != null ? parseFloat(pair.discountValue) : (pair.discountPercent || 15);
            // Saving w walucie sklepu (PLN) – do przekazania do _addLookUpsell (backend/line-item property).
            var savingNumShop = discType === 'FIXED' ? discVal : (priceShop * discVal / 100);
            var savingCentsShop = Math.round(savingNumShop * 100);
            // Saving w walucie rynku – tylko do wyświetlenia w badge'u.
            var savingNum = savingNumShop * fxRate;
            var savingCents = Math.round(savingNum * 100);
            var saving = (window.formatMoney ? window.formatMoney(savingCents) : (savingNum.toFixed(2).replace('.', ',') + ' ' + ((window.cartI18n && window.cartI18n.currencyCode) || '')));
            var completeLookLabel = (window.cartI18n && window.cartI18n.completeLook) || 'Complete the look';
            var imgSrc = upsellProduct.image || '';
            var title = upsellProduct.title || '';

            var safeTitle = title.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
            var imgHtml = imgSrc ? '<img src="' + imgSrc + '" alt="' + safeTitle + '">' : '';

            var discCode = (pair.discountCode || '').toString().replace(/[^A-Za-z0-9_\-]/g, '');
            var html = '<div class="cd-match-box">' +
              '<button type="button" class="cd-match-btn group" onclick="window._addLookUpsell(this, \'' + (upsellProduct.handle || (upsellProduct === pair.productB ? bId : aId)) + '\', ' + savingCentsShop + ', \'' + discCode + '\')">' +
              '<div class="cd-match-img">' + imgHtml + '</div>' +
              '<div style="flex:1">' +
              '<span style="font-size:8px; font-weight:700; color:#6b7280; display:block; text-transform:uppercase;">' + completeLookLabel + '</span>' +
              '<div style="display:flex; align-items:center; margin-top:2px; gap: 6px;">' +
              '<span style="font-size:9px; font-weight:700; text-transform:uppercase;">' + safeTitle + '</span>' +
              '<span class="cd-badge">-' + saving + '</span>' +
              '</div>' +
              '</div>' +
              '<div style="width:20px; height:20px; border:1px solid #e5e7eb; display:flex; align-items:center; justify-content:center; background:#fff;">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg>' +
              '</div>' +
              '</button>' +
              '</div>';

            containers[0].innerHTML = html;
          }
        }
      });
    }

    var base = config && config.loyalty && config.loyalty.pointsPerCurrency != null ? Number(config.loyalty.pointsPerCurrency) : null;
    if (base == null) return;
    var qbMul = (config.loyalty && config.loyalty.quantityBreakMultiplier != null) ? Number(config.loyalty.quantityBreakMultiplier) : 1;
    var bndMul = (config.loyalty && config.loyalty.bundleMultiplier != null) ? Number(config.loyalty.bundleMultiplier) : 1;

    var items = [];
    if (rows.length > 0 && rows[0].hasAttribute('data-cart-items-b64')) {
      try {
        var b64 = rows[0].getAttribute('data-cart-items-b64');
        var jsonStr = decodeURIComponent(escape(window.atob(b64)));
        items = JSON.parse(jsonStr);
      } catch (e) { console.error('Error parsing base64 JSON', e); }
    }
    var totalPoints = 0;
    var seenBundles = {};
    var bundlePointsData = {};
    var rules = Array.isArray(config.rules) ? config.rules : [];
    var qbBestCode = '';
    var qbBestPct = -1;

    items.forEach(function (item) {
      var linePriceCents = item.priceCents;
      var isBundle = item.bundleId !== '';
      var qbActive = false;

      if (!isBundle) {
        var pIdStr = String(item.productId);
        for (var i = 0; i < rules.length; i++) {
          var r = rules[i];
          var rIdM = (r.productId || '').match(/\/(\d+)$/);
          var rId = rIdM ? rIdM[1] : String(r.productId || '');
          if (rId === pIdStr && Array.isArray(r.levels)) {
            var sortedLevels = r.levels.slice().sort(function (a, b) { return b.minQuantity - a.minQuantity; });
            for (var j = 0; j < sortedLevels.length; j++) {
              if (item.quantity >= sortedLevels[j].minQuantity) {
                linePriceCents -= Math.floor(linePriceCents * (sortedLevels[j].discountPercent / 100));
                qbActive = true;
                if (sortedLevels[j].code && sortedLevels[j].discountPercent > qbBestPct) {
                  qbBestPct = sortedLevels[j].discountPercent;
                  qbBestCode = sortedLevels[j].code;
                }
                break;
              }
            }
            break;
          }
        }
      }

      var itemPoints = (linePriceCents / 100) * base;
      if (isBundle) {
        itemPoints *= bndMul;
      } else if (qbActive) {
        itemPoints *= qbMul;
      }

      totalPoints += itemPoints;
      if (isBundle) {
        if (!bundlePointsData[item.bundleId]) bundlePointsData[item.bundleId] = 0;
        bundlePointsData[item.bundleId] += itemPoints;
      }

      if (isBundle && !seenBundles[item.bundleId]) {
        seenBundles[item.bundleId] = true;
        var savingsPln = parseInt(item.bundleSavingsCents || '0', 10) / 100;
        if (isNaN(savingsPln)) savingsPln = 0;
        var savingsPoints = (savingsPln * base) * bndMul;
        totalPoints -= savingsPoints;
        // Keep track of the bundle's total points minus its savings penalty
        bundlePointsData[item.bundleId] -= savingsPoints;
      }
    });

    var finalPoints = Math.round(totalPoints);
    if (finalPoints < 0) finalPoints = 0;

    for (var i = 0; i < rows.length; i++) {
      var span = rows[i].querySelector('.js-loyalty-points');
      if (span) {
        span.textContent = finalPoints + ' pkt';
        span.classList.remove('loyalty-points-pending');
      }
    }

    // Update individual bundle point totals
    var bundleSpans = document.querySelectorAll('.js-loyalty-bundle-points');
    bundleSpans.forEach(function (bSpan) {
      var splitBid = bSpan.getAttribute('data-bundle-id');
      if (splitBid && bundlePointsData[splitBid] != null) {
        bSpan.textContent = Math.max(0, Math.round(bundlePointsData[splitBid]));
      }
    });

    // --- Quantity Breaker: auto-apply discount code via /discount/CODE ---
    try {
      if (qbBestCode && window.__qbAppliedCode !== qbBestCode) {
        var qbIframe = document.getElementById('qb-discount-iframe');
        if (!qbIframe) {
          qbIframe = document.createElement('iframe');
          qbIframe.id = 'qb-discount-iframe';
          qbIframe.style.display = 'none';
          document.body.appendChild(qbIframe);
        }
        qbIframe.src = '/discount/' + encodeURIComponent(qbBestCode);
        document.querySelectorAll('form[action*="/cart"]').forEach(function (form) {
          var input = form.querySelector('input[name="discount"]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'discount';
            form.appendChild(input);
          }
          input.value = qbBestCode;
        });
        window.__qbAppliedCode = qbBestCode;
      } else if (!qbBestCode && window.__qbAppliedCode) {
        // Żaden próg nie jest aktywny – wyczyść wcześniejszy kod QB
        var clearIframe = document.getElementById('qb-discount-iframe');
        if (!clearIframe) {
          clearIframe = document.createElement('iframe');
          clearIframe.id = 'qb-discount-iframe';
          clearIframe.style.display = 'none';
          document.body.appendChild(clearIframe);
        }
        clearIframe.src = '/discount/';
        document.querySelectorAll('form[action*="/cart"] input[name="discount"]').forEach(function (el) {
          if (el.value === window.__qbAppliedCode) el.remove();
        });
        window.__qbAppliedCode = null;
      }
    } catch (e) { console.warn('QB code inject failed', e); }

    // --- Dynamic QB discount badges ---
    // Fix the discount badge % based on actual QB tiers, not the Shopify discount code
    if (rules.length > 0) {
      var cartItemEls = document.querySelectorAll('.cd-item-wrapper[data-product-id]');
      cartItemEls.forEach(function (el) {
        var badge = el.querySelector('.cd-item-qb-badge');
        if (!badge) return;
        var bundleId = el.getAttribute('data-bundle-id') || '';
        if (bundleId) return; // skip bundle items
        var pIdStr = el.getAttribute('data-product-id');
        var qtyInput = el.querySelector('input[data-quantity]');
        var qty = qtyInput ? parseInt(qtyInput.getAttribute('data-quantity') || qtyInput.value || '1', 10) : 1;
        for (var ri = 0; ri < rules.length; ri++) {
          var r = rules[ri];
          var rIdM = (r.productId || '').match(/\/(\d+)$/);
          var rId = rIdM ? rIdM[1] : String(r.productId || '');
          if (rId === pIdStr && Array.isArray(r.levels)) {
            var sortedLevels = r.levels.slice().sort(function (a, b) { return b.minQuantity - a.minQuantity; });
            for (var li = 0; li < sortedLevels.length; li++) {
              if (qty >= sortedLevels[li].minQuantity) {
                var qbTpl = (window.cartI18n && window.cartI18n.qbDiscountTemplate) || 'Discount −__P__%';
                badge.textContent = qbTpl.replace('__P__', sortedLevels[li].discountPercent);
                var wrap = el.querySelector('.cd-item-qb-wrap');
                if (wrap) { wrap.style.display = ''; wrap.style.animation = 'fadeIn .25s ease'; }
                break;
              }
            }
            break;
          }
        }
      });
    }

  }).catch(function (err) { console.error('[LoyaltyPoints] Error:', err); });
};

function triggerLoyaltyUpdate() {
  setTimeout(function () {
    var rows = document.querySelectorAll('.cd-totals-row--points');
    if (rows.length > 0) {
      window.updateCartLoyaltyPoints(rows);
    }
  }, 100);
}

document.addEventListener('baseline:cart:unlock', triggerLoyaltyUpdate);
document.addEventListener('cart:updated', triggerLoyaltyUpdate);
document.addEventListener('DOMContentLoaded', triggerLoyaltyUpdate);
triggerLoyaltyUpdate();

window._addLookUpsell = function (btn, productId, savingCents, discountCode) {
  if (btn.disabled) return;
  btn.disabled = true;
  var originalHtml = btn.innerHTML;
  btn.innerHTML = '<div style="display:flex; align-items:center; justify-content:center; padding: 10px; width: 100%; color: #6b7280; font-size: 10px; font-weight: 700; text-transform: uppercase;">Dodawanie do zestawu...</div>';

  var wrapper = btn.closest('.cd-item-wrapper');
  var triggerKey = wrapper ? wrapper.getAttribute('data-line-item-key') : null;
  var bundleId = 'bnd_' + Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
  savingCents = savingCents || 0;
  discountCode = (discountCode || '').toString().trim();

  var addData = {
    items: [{
      id: null,
      quantity: 1,
      properties: {
        '_multipack_bundle_id': bundleId,
        '_multipack_bundle_savings': savingCents
      }
    }]
  };

  var rootRoute = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  if (rootRoute.charAt(rootRoute.length - 1) !== '/') rootRoute += '/';
  var getProductPromise;
  if (/^\d+$/.test(productId)) {
    getProductPromise = fetch(rootRoute + 'search/suggest.json?q=id:' + productId + '&resources[type]=product', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var pList = data.resources && data.resources.results && data.resources.results.products;
        if (pList && pList.length > 0) {
          var productUrl = pList[0].url.split('?')[0];
          console.log('[DEBUG] Predict API found product URL:', productUrl);
          return fetch(productUrl + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) {
            if (!r.ok) throw new Error('Product fetch failed');
            return r.json();
          });
        }
        throw new Error('Product not found via Predict API');
      });
  } else {
    var rawUrl = productId.split('?')[0];
    getProductPromise = fetch(rootRoute + 'products/' + rawUrl + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('Product fetch failed');
      return r.json();
    });
  }

  // Funkcja właściwego dodania do koszyka (używana zarówno po auto-pick dla one-size, jak i po ręcznym wyborze rozmiaru)
  function doAddToCart(variantId) {
    if (!variantId) throw new Error('No variant ID found in data');
    addData.items[0].id = variantId;

    btn.innerHTML = '<div style="display:flex; align-items:center; justify-content:center; padding: 10px; width: 100%; color: #6b7280; font-size: 10px; font-weight: 700; text-transform: uppercase;">Dodawanie do zestawu...</div>';

    var p1 = fetch(rootRoute + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(addData)
    }).then(function (res) {
      if (!res.ok) { return res.text().then(function (text) { throw new Error('Add failed: ' + text); }); }
      return res.json();
    });

    var p2 = Promise.resolve();
    if (triggerKey) {
      var qtyInput = document.getElementById('updates_' + triggerKey);
      var curQty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      p2 = fetch(rootRoute + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          id: triggerKey,
          quantity: curQty,
          properties: { '_multipack_bundle_id': bundleId, '_multipack_bundle_savings': 0 }
        })
      }).then(function (res) {
        if (!res.ok) { return res.text().then(function (text) { throw new Error('Change failed: ' + text); }); }
        return res.json();
      });
    }

    return Promise.all([p1, p2])
      .then(function () {
        if (discountCode) {
          try {
            var iframe = document.getElementById('look-discount-iframe');
            if (!iframe) {
              iframe = document.createElement('iframe');
              iframe.id = 'look-discount-iframe';
              iframe.style.display = 'none';
              document.body.appendChild(iframe);
            }
            iframe.src = '/discount/' + encodeURIComponent(discountCode);
            document.querySelectorAll('form[action*="/cart"]').forEach(function (form) {
              var input = form.querySelector('input[name="discount"]');
              if (!input) {
                input = document.createElement('input');
                input.type = 'hidden';
                input.name = 'discount';
                form.appendChild(input);
              }
              input.value = discountCode;
            });
          } catch (e) { console.warn('Look discount inject failed', e); }
        }
        var sectionUrl = rootRoute + '?sections=cart-items,cart-footer,cart-item-count,cart-live-region';
        return fetch(sectionUrl)
          .then(function (res) { return res.json(); })
          .then(function (data) {
            document.body.dispatchEvent(new CustomEvent('baseline:cart:cartqtychange', {
              bubbles: true,
              detail: { response: { sections: data }, key: null, quantity: null, originalTarget: null }
            }));
          });
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('baseline:cart:changed'));
        if (window.Alpine && window.Alpine.store && window.Alpine.store('cart')) {
          window.Alpine.store('cart').getCart();
        }
        var card = btn.closest('.cd-match-box');
        if (card) card.remove();
      })
      .catch(function (err) {
        console.error('Upsell add error:', err.message || err);
        btn.innerHTML = originalHtml;
        btn.disabled = false;
      });
  }

  // Pokaż picker rozmiaru, jeśli produkt ma >1 wariant. W przeciwnym razie dodaj od razu.
  function renderVariantPicker(product) {
    var variants = (product.variants || []).filter(function (v) { return v.available !== false; });
    if (variants.length === 0) variants = product.variants || [];

    var chips = variants.map(function (v) {
      var label = (v.title || '').replace(/"/g, '&quot;');
      return '<button type="button" data-vid="' + v.id + '" style="flex:1; min-width:34px; padding:6px 4px; border:1px solid #111; background:#fff; color:#111; font-size:9px; font-weight:800; text-transform:uppercase; cursor:pointer; letter-spacing:0.03em;">' + label + '</button>';
    }).join('');

    btn.innerHTML =
      '<div style="display:flex; flex-direction:column; gap:6px; padding:8px; width:100%;">' +
      '<span style="font-size:8px; font-weight:700; color:#6b7280; text-transform:uppercase; letter-spacing:0.05em;">' + ((window.cartI18n && window.cartI18n.selectSize) || 'Select a size') + '</span>' +
      '<div style="display:flex; gap:4px; flex-wrap:wrap;">' + chips + '</div>' +
      '</div>';

    btn.disabled = false;
    btn.querySelectorAll('button[data-vid]').forEach(function (chip) {
      chip.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        btn.disabled = true;
        var vid = chip.getAttribute('data-vid');
        doAddToCart(vid).catch(function () { /* already handled */ });
      });
    });
  }

  getProductPromise
    .then(function (product) {
      console.log('[DEBUG] Fetched product data:', JSON.parse(JSON.stringify(product || {})));
      var variants = product.variants || [];
      var isOneSize = variants.length <= 1 || (variants.length === 1 && (variants[0].title === 'Default Title' || variants[0].title === 'Domyślny tytuł'));

      if (isOneSize) {
        var variantId = (variants[0] && variants[0].id) || product.id;
        return doAddToCart(variantId);
      }

      // Pokaż picker rozmiaru – czekamy na klik użytkownika
      renderVariantPicker(product);
      return null;
    })
    .catch(function (err) {
      console.error('Upsell fetch error:', err.message || err);
      btn.innerHTML = originalHtml;
      btn.disabled = false;
    });
};

/* legacy _addLookUpsell tail removed – merged into doAddToCart() */

